/** The site header. `home` prefixes the section anchors, so the links also work from /evidence. */
export function Header({ home = '' }: { home?: string }) {
  return (
    <header className="top">
      <a className="wordmark" href={home || '#'}>Bellguard</a>
      <nav className="nav" aria-label="Sections">
        <a href={`${home}#gap`}>The gap</a>
        <a href={`${home}#contracts`}>Contracts</a>
        <a href={`${home}#deployed`}>Deployed</a>
        <a href={`${home}#verify`}>Verify a token</a>
        <a href={`${home}#quote`}>Fee quote</a>
        <a href={`${home}#fees`}>Fee log</a>
        <a href={`${home}#check`}>Check a token</a>
        <a href={`${home}#faq`}>FAQ</a>
        <a href={`${home}#status`}>Status</a>
        <a href="/evidence">Evidence</a>
      </nav>
    </header>
  );
}
